export default "__VITE_ASSET__8d595697__"